import {_request} from '../http'

export async function signIn(auth) {
    return _request("POST", `/auth/admin`, auth)
}